"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReleaseNotes = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_markdown_1 = __importDefault(require("react-markdown"));
const ReleaseNotes_md_1 = __importDefault(require("../ReleaseNotes.md"));
const react_bootstrap_1 = require("react-bootstrap");
function ReleaseNotes({ version }) {
    const [show, setShow] = (0, react_1.useState)(false);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_bootstrap_1.Button, { className: "show-release-notes", onClick: () => setShow(true), variant: "secondary", children: version }), (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Modal, { show: show, onHide: () => setShow(false), children: [(0, jsx_runtime_1.jsx)(react_bootstrap_1.Modal.Header, { children: "Release Notes" }), (0, jsx_runtime_1.jsx)(react_bootstrap_1.Modal.Body, { children: (0, jsx_runtime_1.jsx)(react_markdown_1.default, { children: ReleaseNotes_md_1.default }) })] })] }));
}
exports.ReleaseNotes = ReleaseNotes;
